export default __webpack_public_path__ + "static/media/error_404.8847fd95.png";